import Loadable from 'react-loadable';

const LazyPrivacySettings = Loadable({
  loader: () =>
    import(/* webpackChunkName: "settings/privacy-settings" */ './'),
  loading: () => null,
});
LazyPrivacySettings.displayName = 'lazy(PrivacySettings)';
export default LazyPrivacySettings;
